import { PBBStorageData } from "./stateManager";

export class LocalStorage {
  private storage: Map<string, string> = new Map();
  private readonly PBB_KEY = "PopularBetBuildersStorageV1";

  setPBBData(data: PBBStorageData): void {
    localStorage.setItem(this.PBB_KEY, JSON.stringify(data));
  }

  getPBBData(): PBBStorageData | null {
    const data = localStorage.getItem(this.PBB_KEY);
    return data ? JSON.parse(data) : null;
  }

  clearPBBData(): void {
    this.storage.delete(this.PBB_KEY);
  }
}
